<template>
    <div class="configurations">
        <div class="columns">
            <div class="column is-12">
                <div class="card">
                    <header class="card-header has-background-light is-size-4">
                        <p class="card-header-title">Tags</p>
                        <div class="buttons" v-if="canCreateTags">
                            <b-button size="is-small" @click="isCreateTag=true">CREATE</b-button>
                        </div>
                    </header>
                    <div class="card-content scrollable">
                        <b-table :data="tags" hovered bordered striped :loading="loading">
                            <template slot-scope="props">
                                <b-table-column field="name" label="Name">
                                    {{props.row.name}}
                                    <!-- <span v-if="props.row.pivot && props.row.pivot.archived_at">[DELETED]</span> -->
                                    <template v-if="isSuperAdmin">
                                        <button
                                        :class="'button is-small' + (isSystem(props.row) ? ' is-info' : '')"
                                        :disabled="!isSuperAdmin"
                                        style="float:right;"
                                        @click="toggleTag(props.row, $event)"
                                        >
                                            SYSTEM
                                        </button>
                                    </template>
                                </b-table-column>
                                <b-table-column field="type" label="Type">{{props.row.type}}</b-table-column>
                                <b-table-column field="id" label width="40" class="no-wrap">
                                    <b-button
                                        @click.prevent="getAssociates(props.row)"
                                        size="is-small"
                                        ref="test"
                                    >ASSOCIATED</b-button>
                                    <b-button
                                        @click.prevent="updateTag(props.row)"
                                        size="is-small"
                                        ref="test"
                                        v-if="!organization"
                                    >EDIT</b-button>
                                    <b-button
                                        @click.prevent="deleteTag(props.row)"
                                        size="is-small"
                                        ref="test"
                                        v-if="!organization"
                                    >DELETE</b-button>
                                    <b-button
                                        size="is-small"
                                        :type="props.row.pivot.archived_at ? 'is-warning' : ''"
                                        @click="toggleArchive(props.row)"
                                        v-if="organization && props.row.pivot"
                                    >
                                        {{ props.row.pivot.archived_at ? 'RESTORE' : 'ARCHIVE' }}
                                    </b-button>
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
        <b-modal :active.sync="displayAssociates" has-modal-cardtrap-focus aria-role="dialog" aria-modal>
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">ASSOCIATED</p>
                </header>
                <section class="modal-card-body">
                    <div class="b-table">
                        <div class="table-wrapper">
                           <table class="table is-striped" style="min-width:500px;">
                               <tr>
                                   <td>Name</td>
                                   <td>Type</td>
                               </tr>
                               <tr v-for="(row, key) in associates">
                                   <td>{{ row.name }}</td>
                                   <td>{{ row.type }}</td>
                               </tr>
                           </table>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                </footer>
            </div>
        </b-modal>
        <b-modal :active.sync="isCreateTag" has-modal-card trap-focus aria-role="dialog" aria-modal>
            <create-tag-modal :organization="organization" @newTag="newTag" v-if="isCreateTag" />
        </b-modal>
        <b-modal :active.sync="isUpdateTag" has-modal-card trap-focus  aria-modal>
            <update-tag-modal :tag="selectedTag" @tagUpdated="tagUpdated"/>
        </b-modal>
    </div>
</template>
<script>
import { FirmService } from "@/services/firm.service";
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import createTagModal from "./partials/createTagModal";
import updateTagModal from "./partials/updateTagModal";
import { systemTagMixin } from '@/mixins/systemTagMixin';

export default {
    tagService: TagService,
    props: {
        organization: {
            type: Object
        }
    },
    mixins: [ systemTagMixin ],
    components: {
        createTagModal,
        updateTagModal
    },
    data: () => ({
        tags: [],
        loading: false,
        isCreateTag: false,
        isUpdateTag: false,
        selectedTag: null,
        associates: [],
        displayAssociates: false,
    }),
    computed: {

        associated() {
            return 'asd';
        },
        canCreateTags() {
            return this.$store.getters["Auth/hasPermission"]("can create tags");
        }
    },
    created() {
        this.getTags();
        this.getTagList();
    },
    methods: {
        async getTagList() {
            try {
                this.loading = true;

                if (this.organization) {
                    this.tags = await FirmService.listTags(this.organization.id).then(response => JsonDenormalizer.denormalize(response));
                } else {
                    this.tags = await this.$options.tagService
                        .all()
                        .then(response => JsonDenormalizer.denormalize(response));
                }
            } catch (err) {}
            this.loading = false;
        },
        newTag(tag) {
            // this.tags.push(tag);
            this.getTagList();
        },
        updateTag(tag){
            this.isUpdateTag = true
            this.selectedTag = tag
        },
        async deleteTag(tag) {
            try {
                this.loading = true;
                await this.$options.tagService.delete(tag.id);

                const index = this.tags.indexOf(tag);
                if (index > -1) {
                    this.tags.splice(index, 1);
                }
            } catch (err) {}
            this.loading = false;
        },
        async toggleArchive(tag) {
            try {
                this.loading = true;
                if (tag.pivot.archived_at) {
                    await FirmService.unarchiveTag(this.organization.id, tag.id);
                } else {
                    await FirmService.archiveTag(this.organization.id, tag.id);
                }
                await this.getTagList();
            } catch (err) {
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
        tagUpdated(tag){
            const index = this.tags.indexOf(this.selectedTag);
            this.$set(this.tags,index, tag)
        },
        async toggleTag(row, event) {
            await TagService.toggleTag({id: row.id}).then(response => {
                this.$buefy.toast.open({
                  message: "Success",
                  type: "is-success",
                  position: "is-top-right"
                });
            });
            event.target.classList.toggle('is-info')
        },
        async getTags() {
            await TagService.getTags().then(response => {
                this.nativeData = response;
            });
        },
        async getAssociates(row) {
            await TagService.associates({id: row.id}).then(response => {
                // console.log(this.tags.filter(element => response.includes(parseInt(element.id))));
                this.associates = this.tags.filter(element => response.includes(parseInt(element.id)));
                this.displayAssociates = true;
            });
        }
    }
};
</script>

<style scoped>
.scrollable {
    height: calc(100vh - 6.5rem);
}
.no-wrap {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Tags/list/index.vue